export enum AccessibilityViewIndex {
  CLOSED = -1,
  CHECK = 0,
  EDIT = 1,
  SIMULATOR = 2,
}
